import { getServerDate } from "../utils/storage/date";
import { IHashMap, IModifiedType } from "../sync/sync.types";
import idSerializer from "geotab-uuid";
import { NOUSERID } from "./DutyStatusLog";

export interface IUserHosRuleSet extends IHashMap<IUserHosRuleSet> {
    id: string;
    user: IIdEntity;
    dateTime: string;
    hosRuleSet: IIdEntity;
    startOfDay?: string;
}

export default class UserHosRuleSet implements IUserHosRuleSet {

    id: string;
    user: IIdEntity;
    dateTime: string;
    hosRuleSet: IIdEntity;
    startOfDay?: string;

    modified?: IModifiedType;
    previousState?: IUserHosRuleSet;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;

    constructor (obj: DeepReadonly<IUserHosRuleSet>) {
        this.id = obj.id || idSerializer.get();
        this.user = obj.user && obj.user.id ? obj.user : { id: NOUSERID };
        this.dateTime = obj.dateTime || getServerDate().toISOString();
        this.hosRuleSet = obj.hosRuleSet || { id: "" };
        this.startOfDay = obj.startOfDay;

        this.modified = obj.modified;
        this.previousState = obj.previousState;
        this._syncCounter = obj._syncCounter || 5;
    }

    toJSON(): IUserHosRuleSet {
        return {
            id: this.id,
            user: this.user,
            dateTime: this.dateTime,
            hosRuleSet: this.hosRuleSet,
            startOfDay: this.startOfDay,
            modified: this.modified,
            previousState: this.previousState
        };
    }
}